import axios from 'axios';
import Vue from 'vue';

const retryTime = 30000;

export default {
  namespaced: true,
  state: {},
  mutations: {
    addConfiguration(state, { config, data }) {
      if (data?.data?.data !== undefined)
        data = data.data.data;
      else if (data?.data !== undefined)
        data = data.data;

      Vue.set(state, axios.getUri(config), Object.freeze(data));
    },
    resetStore(state) {
      /* Vue.set(state, {}); */
      for (const key of Object.keys(state)) {
        delete state[key];
      }
    }
  },
  getters: {
    getConfiguration: state => config => {
      const data = state[axios.getUri(config)];
      if (data?.isLoading) return undefined;
      else return data;
    }
  },
  actions: {
    loadConfiguration({ commit, state }, config) {
      if (state[axios.getUri(config)]?.isLoading) return;
      commit('addConfiguration', { config, data: { isLoading: true } });
      axios({ ...config, method: 'get' }).then(
        response => commit('addConfiguration', { config, data: response }),
        () => window.setTimeout(() => commit('addConfiguration', { config, data: undefined }), retryTime)
      );
    },
    loadConfigurationWithSamePath({ commit, state}, config) {
      for (const [key, value] of Object.entries(state)) {
        if (key.includes(config.url)) {
          let uri = axios.getUri(value.config);
          if (state[uri]?.isLoading) return;

          let conf = state[uri]?.config;
          axios({ ...conf, method: 'get' }).then(
            response => commit('addConfiguration', { config: conf, data: response }),
            () => window.setTimeout(() => commit('addConfiguration', { config: conf, data: undefined }), retryTime)
          )
        }
      }
    },
    resetStore({ commit }) {
      commit('resetStore');
    }
  }
}
